import { UntypedFormControl, ValidatorFn } from '@angular/forms';
export class PasswordValidators {
  static oneDigitRule(): ValidatorFn {
    return (control: UntypedFormControl) => {
      const re = /\d/;

      if (!re.test(control.value)) {
        return { digitCharacterRule: true };
      }

      return null;
    };
  }

  static lowercaseCharacterRule(): ValidatorFn {
    return (control: UntypedFormControl) => {
      const re = /[a-z]/;

      if (!re.test(control.value)) {
        return { lowercaseCharacterRule: true };
      }

      return null;
    };
  }

  static uppercaseCharacterRule(): ValidatorFn {
    return (control: UntypedFormControl) => {
      const re = /[A-Z]/;

      if (!re.test(control.value)) {
        return { uppercaseCharacterRule: true };
      }

      return null;
    };
  }
}
